<div class="grid-container margin-top">

  @if (selectedTemplate) {
    <div>
      <communication-template-editor
        [allTemplates]="data"
        [template]="selectedTemplate"
        [types]="types"
        [chiefsOrderCategories]="chiefOrderCategories"
        [letterCategories]="letterCategories"
        [reminderTypes]="reminderTypes"
        (closed)="closeEditor()"
      (templateSaved)="onTemplateSaved($event)"></communication-template-editor>
    </div>
  } @else {
    <button class="button" (click)="addTemplate()">Add a Template</button>
    <ag-grid-angular class="data-grid  wide-ag-menu" [rowData]="data" [gridOptions]="gridOptions" aria-label="Communication Templates">
    </ag-grid-angular>
  }

</div>
